(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    (function() {
function initializeTabs() {
    document.querySelectorAll('.tabs').forEach(container => {
    const panels = container.querySelectorAll('.tabs__panel');
    const navContainer = container.querySelector('.tabs__nav');
    
    if (panels.length && navContainer) {
        // Clear and rebuild navigation from panel elements
        navContainer.innerHTML = '';
        
        panels.forEach((panel, index) => {
        const tab = panel.querySelector('.tab[data-tab-heading]');
        const heading = tab ? (tab.dataset.tabHeading || `Tab ${index + 1}`) : `Tab ${index + 1}`;
        const button = document.createElement('button');
        button.className = `tabs__button ${index === 0 ? 'is-active' : ''}`;
        button.type = 'button';
        button.dataset.tabTarget = panel.id;
        button.textContent = heading;
        navContainer.appendChild(button);
        });
    }
    
    const buttons = container.querySelectorAll('.tabs__button');
    
    buttons.forEach(button => {
        button.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));
        button.classList.add('is-active');
        const targetPanel = container.querySelector(`#${button.dataset.tabTarget}`);
        if (targetPanel) targetPanel.classList.add('is-active');
        });
    });
    });
}

// Run immediately if DOM is ready, otherwise wait
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTabs);
} else {
    initializeTabs();
}

// Re-run after Shopify editor changes
document.addEventListener('shopify:section:load', initializeTabs);
document.addEventListener('shopify:block:select', initializeTabs);
})();
  } catch(e) { console.error(e); }
})();

})();
